module.exports = __webpack_public_path__ + "static/img/gov.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gov.png
// module id = C5Iw
// module chunks = 3